import api from "../../../api";
import {typedQuery} from "../../typing";

export const auditAreaTemplates = typedQuery(["tprm", "auditAreaTemplates"], async () => {
  return await api.tprm.auditAreaTemplates.list();
});
